import { DashboardMeasureDetailProd } from "@models/dashboard-measure-details.model";

const RETIRED_MEASURES: Record<number, string[]> = {
  2026: ["QPP-419", "QPP-487"],
};

export function applyYearRetirements(
  measures: DashboardMeasureDetailProd[],
  year: number,
): DashboardMeasureDetailProd[] {
  const retired = RETIRED_MEASURES[year] ?? [];
  if (retired.length === 0) return measures;
  return measures.filter((m) => !retired.includes(m.name ?? ""));
}
